import { Address, emptyAddress } from './address';

export interface Company {
	id: string;
	name: string;
	taxId?: string;
	address: Address;
	active: boolean;
	slugId?: string;
	timezone?: string;
	companyType?: 'advanced' | 'care';
	deidentification?: number;
	keyDetection?: boolean;
	hideFromPublicDirectory?: boolean;
	smsNotifications?: boolean;
	contactNotifications?: boolean;
	ajaxEnabled?: boolean;
	ajaxUsername?: string;
	ajaxPassword?: string;
	apiEnabled?: boolean;
	apiUsernames?: string[];
	ancestorOfCompany?: boolean;
	isSentrilock?: boolean;
	deviceRemovalAccessOptions?: boolean;
	requireReasonForCodeGeneration?: boolean;
	hasClientAccess?: boolean;
}

export interface FlattenedCompany {
	id: string;
	name: string;
	taxId?: string;
	addressId?: string;
	address1?: string;
	address2?: string;
	locality?: string;
	stateProvinceRegion?: string;
	postalCode?: string;
	countryCode?: string;
	active: boolean;
	slugId?: string;
	timezone?: string;
	deidentification?: number;
	keyDetection?: boolean;
	hideFromPublicDirectory?: boolean;
	ajaxEnabled?: boolean;
	ajaxUsername?: string;
	ajaxPassword?: string;
	apiEnabled?: boolean;
	apiUsernames?: string;
	smsNotifications?: boolean;
	contactNotifications?: boolean;
	deviceRemovalAccessOptions?: boolean;
	requireReasonForCodeGeneration?: boolean;
}

export const emptyCompany = (): Company => ({
	id: '',
	name: '',
	taxId: '',
	address: emptyAddress(),
	active: true,
	requireReasonForCodeGeneration: true,
});

export const emptyFlattenedCompany = (): FlattenedCompany => ({
	id: '',
	name: '',
	taxId: '',
	addressId: '',
	active: true,
});
